export default {
  // START:: GET APP LOCALE
  getAppLocale(state) {
    return state.Fans_admin_dashboard_language;
  },
  // END:: GET APP LOCALE
};
